enum ECalendarSymbol {
  Y = 'y',
  M = 'm',
  D = 'd',
}

export default ECalendarSymbol;
